// extracted by mini-css-extract-plugin
module.exports = {"main":"_95Vch"};